/**
 * Chave da "seção" de topo de uma rota = o primeiro segmento do path. Usada para
 * animar a troca de conteúdo apenas ao mudar de seção (ex.: /chats → /contatos),
 * sem remontar/animar ao navegar DENTRO da mesma seção (ex.: /chats → /chats/:id
 * deep-link, que precisa preservar estado, socket e a conversa aberta).
 */
export function getRouteSectionKey(pathname: string): string {
  const [firstSegment] = pathname.split("/").filter(Boolean);
  return firstSegment ?? "root";
}
